class AddressElementsInCheckout {
	constructor(section) {
		this.addressSearchSection = section;
		this.currentAddressCard = this.addressSearchSection.querySelector(
			'.js-current-address-static-card',
		);
		this.addressForm = this.addressSearchSection.querySelector(
			'.js-address-results-wrapper',
		);
		this.addressSearchBlock = this.addressSearchSection.querySelector(
			'.js-address-search-block',
		);
		this.sameAddressCheckbox = document.querySelector('#sameAsAddressCheckBox');
		this.isSameAddressValidInput = document.querySelector(
			'input[name="isSameAddressValid"]',
		);
		this.isAddressValidInput = document.querySelector(
			'input[name="validAddress"]',
		);
		this.addressSearchInputs = this.addressSearchSection.querySelectorAll(
			'.js-address-search-input',
		);
		this.firstPhoneInput = this.addressSearchSection.querySelector(
			'.js-address-phone-first',
		);
		this.secondPhoneInput = this.addressSearchSection.querySelector(
			'.js-address-phone-second',
		);
		this.defaultAddressCard = this.addressSearchSection.querySelector(
			'.js-default-address-static-card',
		);

		this.inputSpecialDelivery = null;
		this.charCountContainer = null;
		this.charCountDisplay = null;
	}

	displaySecondPhoneInput(shouldBeDisplayed) {
		if (shouldBeDisplayed) {
			this.secondPhoneInput.classList.remove('hidden');
			this.secondPhoneInput
				.querySelector('input')
				.setAttribute('name', 'phone');
		} else {
			this.secondPhoneInput.classList.add('hidden');
			this.secondPhoneInput.querySelector('input').removeAttribute('name');
		}
	}

	addNameToFirstPhoneInput(shouldBeAdded) {
		if (shouldBeAdded) {
			this.firstPhoneInput.querySelector('input').setAttribute('name', 'phone');
		} else {
			this.firstPhoneInput.querySelector('input').removeAttribute('name');
		}
	}

	displayBlocksForNewUser() {
		if (!this.sameAddressCheckbox.checked) {
			if (
				this.defaultAddressCard.querySelector('.js-address-card-line2')
					.textContent &&
				this.defaultAddressCard
					.querySelector('.js-address-card-line2')
					.textContent.replace(/\s+/g, '').length > 0
			) {
				this.defaultAddressCard.classList.remove('hidden');
				this.addressSearchBlock.classList.add('hidden');
			} else {
				this.defaultAddressCard.classList.add('hidden');
				this.addressSearchBlock.classList.remove('hidden');
			}

			if (this.secondPhoneInput) {
				this.displaySecondPhoneInput(false);
				this.addNameToFirstPhoneInput(true);
			}

			if (document.querySelector('#enterDeliveryAddress')) {
				document
					.querySelector('#enterDeliveryAddress')
					.classList.remove('d-none');
			}
		} else {
			this.defaultAddressCard.classList.add('hidden');
			this.addressSearchBlock.classList.add('hidden');

			if (this.secondPhoneInput) {
				this.displaySecondPhoneInput(true);
				this.addNameToFirstPhoneInput(false);
			}

			if (document.querySelector('#enterDeliveryAddress')) {
				document.querySelector('#enterDeliveryAddress').classList.add('d-none');
			}
		}
	}

	setValueOfSecondBillingPhoneInput() {
		const valueOfDeliveryPhone = document.querySelector(
			'.js-delivery-address-phone',
		).value;

		if (valueOfDeliveryPhone) {
			this.secondPhoneInput.querySelector('input').value = valueOfDeliveryPhone;
		} else if (!valueOfDeliveryPhone && !this.sameAddressCheckbox.checked) {
			this.secondPhoneInput.querySelector('input').value = '09999999999';
		} else if (!valueOfDeliveryPhone && this.sameAddressCheckbox.checked) {
			this.secondPhoneInput.querySelector('input').value = '';
		}
	}

	changeValidAddressValue() {
		if (
			this.sameAddressCheckbox.checked &&
			this.isSameAddressValidInput &&
			this.isAddressValidInput
		) {
			this.isAddressValidInput.value = this.isSameAddressValidInput.value;
		} else {
			this.isAddressValidInput.value = 'false';
		}

		this.isAddressValidInput.dispatchEvent(
			new Event('change', { bubbles: true }),
		);
	}

	hideAddressCard() {
		if (this.currentAddressCard) {
			this.currentAddressCard.classList.add('d-none');
		}

		this.addressSearchSection
			.querySelectorAll('.js-address-title')
			.forEach(title => {
				title.classList.add('d-none');
			});
	}

	setAddressCardValues() {
		const currentCountry = document.querySelector('.js-current-country');
		const line1 = this.currentAddressCard.querySelector(
			'.js-address-card-line1',
		);
		const line2 = this.currentAddressCard.querySelector(
			'.js-address-card-line2',
		);
		const line3 = this.currentAddressCard.querySelector(
			'.js-address-card-line3',
		);
		const line4 = this.currentAddressCard.querySelector(
			'.js-address-card-line4',
		);
		const addressLine1Value =
			this.addressSearchSection.querySelector('.js-address-line-1').value;
		const addressLine2Value =
			this.addressSearchSection.querySelector('.js-address-line-2').value;
		const cityValue =
			this.addressSearchSection.querySelector('.js-address-city').value;
		const postalCodeValue = this.addressSearchSection.querySelector(
			'.js-address-postal-code',
		).value;

		if (currentCountry.value === 'en' || currentCountry.value === 'en_IE') {
			line1.textContent = addressLine2Value;
			line2.textContent = addressLine1Value;
			line3.textContent = cityValue;
			line4.textContent = postalCodeValue;
		} else {
			line1.textContent = addressLine1Value;
			line2.textContent = addressLine2Value;
			line3.textContent = `${postalCodeValue} ${cityValue}`;
		}
	}

	resetSearchInputsValidation() {
		this.addressSearchInputs.forEach((input, index) => {
			input.classList.remove('valid', 'invalid');
			if (index > 0) {
				input.setAttribute('disabled', true);
			}
		});
	}

	showTipForDeliveryAddress() {
		this.inputSpecialDelivery = document.querySelector(
			'input[name="specialDeliveryInfo"]',
		);

		if (this.inputSpecialDelivery) {
			this.charCountContainer = document.querySelector(
				'.special-delivery-info-tip.d-none',
			);
			this.charCountDisplay = this.charCountContainer.querySelector(
				'.char-count-display',
			);

			const maxChars = 100;

			const countCharacters = event => {
				const inputLength = event.target.value.length;
				const remainingChars = maxChars - inputLength;
				this.charCountDisplay.textContent = remainingChars;

				if (
					inputLength > 0 &&
					this.charCountContainer.classList.contains('d-none')
				) {
					this.charCountContainer.classList.remove('d-none');
				} else if (
					inputLength === 0 &&
					!this.charCountContainer.classList.contains('d-none')
				) {
					this.charCountContainer.classList.add('d-none');
				}

				if (
					inputLength >= maxChars &&
					!this.inputSpecialDelivery.classList.contains('is-invalid')
				) {
					this.inputSpecialDelivery.classList.add('is-invalid');
				} else if (
					inputLength < maxChars &&
					this.inputSpecialDelivery.classList.contains('is-invalid')
				) {
					this.inputSpecialDelivery.classList.remove('is-invalid');
				}
			};

			if (this.charCountDisplay) {
				this.inputSpecialDelivery.addEventListener('input', countCharacters);

				countCharacters({ target: this.inputSpecialDelivery });
			}
		}
	}

	listeners() {
		if (
			this.sameAddressCheckbox &&
			(window.location.href.includes('billing') ||
				window.location.href.includes('delivery'))
		) {
			this.displayBlocksForNewUser();
			if (this.secondPhoneInput) {
				this.setValueOfSecondBillingPhoneInput();
			}

			this.sameAddressCheckbox.addEventListener('change', () => {
				this.resetSearchInputsValidation();
				this.displayBlocksForNewUser();
				this.changeValidAddressValue();
				if (this.secondPhoneInput) {
					this.setValueOfSecondBillingPhoneInput();
				}
			});
		}

		if (
			(window.location.href.includes('delivery') ||
				window.location.href.includes('billing')) &&
			this.currentAddressCard
		) {
			this.showTipForDeliveryAddress();

			if (!this.addressSearchSection.querySelector('.js-address-city').value) {
				this.hideAddressCard();
			} else {
				this.setAddressCardValues();
				setTimeout(() => {
					this.currentAddressCard.classList.remove('d-none');
				}, 400);
			}
		}
	}

	init() {
		this.listeners();
	}
}

export default AddressElementsInCheckout;
